import api from '@/services/api'
import { METHOD, request } from '@/utils/request'

export const dataApi = {
    async selection(params) {
        return request(api.visit.SELECT_DEPT, METHOD.GET, params)
    },
    async deleteTask(keyId) {
        return request(api.visitTask.DEL + "/" + keyId, METHOD.GET);
    },
    async getFormDetail(keyId) {
        return request(api.visitTask.DETAIL + "/" + keyId, METHOD.GET);
    },
    async insertData(result) {
        return request(api.visitTask.INSERT, METHOD.POST, result);
    },
    async updateData(result) {
        return request(api.visitTask.UPDATE, METHOD.POST, result);
    },
}

export default { dataApi }
